import BaseInput from "../components/base/BaseInput.vue";
import BaseRadio from "../components/base/BaseRadio.vue";
import BaseSelect from "../components/base/BaseSelect.vue";
import BaseForm from "../components/base/BaseForm.vue";

export function registerGlobalComponents(app) {
  app.component("BaseInput", BaseInput);
  app.component("BaseRadio", BaseRadio);
  app.component("BaseSelect", BaseSelect);
  app.component("BaseForm", BaseForm);
}


